import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["data-text"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["inner-tile-section", {'odd-tiles': !_ctx.isTileNumberEven}])
  }, [
    _createElementVNode("h2", {
      class: "section-heading",
      "data-text": _ctx.sectionTitle
    }, null, 8, _hoisted_1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contents, (content) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "project-tile glass-tile",
        ref_for: true,
        ref: "projectTile",
        key: content.title
      }, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.modalComp), {
          data: content,
          onHideModals: _ctx.hideModals
        }, null, 40, ["data", "onHideModals"]))
      ]))
    }), 128))
  ], 2))
}